import _regeneratorRuntime from "@babel/runtime/regenerator";

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

import React from 'react';
import { utils } from '../../utils/utils';
import { ARTSTORE_PUBSUB_ENUMS, ART_STORE, ALBUMS } from '../consts';
import wixAppsApi from './wixAppsApi';
import UpgradeToBusinessPopup from '../checkout/popupMessage/upgradeToBusinessPopup';
import { experimentsWrapper } from '@wix/photography-client-lib';

var CheckoutHandler = /*#__PURE__*/function () {
  function CheckoutHandler(baseUrl, closeFullscreen) {
    this.baseUrl = baseUrl;
    this.closeFullscreen = closeFullscreen;
    this.checkoutParams = null;
    this.popupParams = {
      businessPlanUrl: null
    };
  }

  var _proto = CheckoutHandler.prototype;

  _proto.getCheckoutData = function getCheckoutData() {
    return this.checkoutParams;
  };

  _proto.setCheckoutData = function setCheckoutData(data) {
    this.checkoutParams = data;
  };

  _proto.handleCheckoutRequest = /*#__PURE__*/function () {
    var _handleCheckoutRequest = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(data, checkputParams) {
      var locale, additionalProviderParams, srcId, isAlbumStore, enableAlbumsStorePremiumValidation, isContainsDemoItems, shouldProceedToCheckout, appDefId, appsApi, _yield$appsApi$getSit, hasBusinessPackage, metaSiteId;

      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              locale = data.locale, additionalProviderParams = data.additionalProviderParams;
              srcId = additionalProviderParams.srcId, isAlbumStore = additionalProviderParams.isAlbumStore;
              enableAlbumsStorePremiumValidation = experimentsWrapper.getExperimentBoolean('specs.pro-gallery.EnableAlbumsStorePremiumValidation');
              isContainsDemoItems = this.containsDemoItems(data);
              shouldProceedToCheckout = true;

              if (!isContainsDemoItems) {
                _context.next = 10;
                break;
              }

              this.openDemoItemsPopup(data);
              shouldProceedToCheckout = false;
              _context.next = 19;
              break;

            case 10:
              if (!(enableAlbumsStorePremiumValidation && isAlbumStore)) {
                _context.next = 19;
                break;
              }

              appDefId = isAlbumStore ? ALBUMS.ALBUMS_APP_DEF_ID : ART_STORE.ARTSTORE_APP_DEFINITION_ID;
              appsApi = wixAppsApi[appDefId];
              _context.next = 15;
              return appsApi.getSiteBusinessPackageData(locale, srcId, this.baseUrl);

            case 15:
              _yield$appsApi$getSit = _context.sent;
              hasBusinessPackage = _yield$appsApi$getSit.hasBusinessPackage;
              metaSiteId = _yield$appsApi$getSit.metaSiteId;

              if (!hasBusinessPackage) {
                this.popupParams.businessPlanUrl = appsApi.getSitebusinessPlanUrl(metaSiteId);
                this.openBusinessPackagePopup(data);
                shouldProceedToCheckout = false;
              }

            case 19:
              if (shouldProceedToCheckout) {
                this.proceedToCheckout(data, checkputParams);
              }

            case 20:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, this);
    }));

    function handleCheckoutRequest(_x, _x2) {
      return _handleCheckoutRequest.apply(this, arguments);
    }

    return handleCheckoutRequest;
  }();

  _proto.openDemoItemsPopup = function openDemoItemsPopup(data) {
    var isMobile = data.isMobile,
        storeApi = data.storeApi;
    var width = isMobile ? '100%' : 600;
    var height = isMobile ? '100%' : 300;
    var url = utils.generateUrl('checkout-popup-message.html');
    storeApi.openPopup(url, {
      width: width,
      height: height
    });

    if (typeof this.closeFullscreen === 'function') {
      this.closeFullscreen();
    }

    data.changeStoreFrameState(ARTSTORE_PUBSUB_ENUMS.CART, false);
  };

  _proto.openBusinessPackagePopup = function openBusinessPackagePopup(data) {
    data.changeStoreFrameState(ARTSTORE_PUBSUB_ENUMS.STORE_POPUP_MESSAGE, true);
  };

  _proto.proceedToCheckout = function proceedToCheckout(data, additionalParams) {
    this.setCheckoutData(additionalParams || {});
    data.changeStoreFrameState(ARTSTORE_PUBSUB_ENUMS.CHECKOUT, true);
  };

  _proto.containsDemoItems = function containsDemoItems(data) {
    var cartItems = data.cartItems;

    if (!cartItems) {
      return false;
    }

    var demoItems = cartItems.filter(function (item) {
      return item.isDemo;
    });
    return demoItems.length > 0;
  };

  _proto.getCheckoutPopupMessage = function getCheckoutPopupMessage(data) {
    return this.getUpgradeToBusinessPopup(data);
  };

  _proto.getUpgradeToBusinessPopup = function getUpgradeToBusinessPopup(data) {
    return /*#__PURE__*/React.createElement("div", {
      className: "artstore-popup-message-element-wrapper"
    }, /*#__PURE__*/React.createElement(UpgradeToBusinessPopup, {
      isMobile: data.isMobile,
      viewMode: data.viewMode,
      businessPlanUrl: this.popupParams.businessPlanUrl,
      closePopup: function closePopup() {
        return data.changeStoreFrameState(ARTSTORE_PUBSUB_ENUMS.STORE_POPUP_MESSAGE, false);
      }
    }));
  };

  return CheckoutHandler;
}();

export { CheckoutHandler as default };